// const SERVICE_ID="service_mox7cdg"
// const TEMPLATE_ID="template_116y6kc" 
// const USER_ID="user_EHozNXxBeeac76WUyQvwe"

const SERVICE_ID="service_spyzccf"
const TEMPLATE_ID="template_rwjknf8" 
const USER_ID="user_vponeLZVFWtRm67TYoxyx"

export {SERVICE_ID,TEMPLATE_ID,USER_ID}